module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "selectRow"
  }, [_c('el-col', [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-select', {
    staticClass: "xs24",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请输入发行游戏名称"
    },
    model: {
      value: (_vm.pdata.issued_app_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "issued_app_id", $$v)
      },
      expression: "pdata.issued_app_id"
    }
  }, _vm._l((_vm.PlacementList), function(item, i) {
    return _c('el-option', {
      key: item.issued_app_id,
      attrs: {
        "label": item.name,
        "value": item.issued_app_id
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 1)
      }
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 0)
      }
    }
  }, [_vm._v("禁用")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.plist,
      "stripe": "",
      "row-key": "id"
    },
    on: {
      "selection-change": _vm.select,
      "sort-change": _vm.tableSort
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "issued_app_id",
      "label": "ID",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "流量主游戏名称",
      "align": "left",
      "min-width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: '创意投放',
                params: {
                  issued_app_id: scope.row.issued_app_id
                }
              })
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "version",
      "label": "版本号",
      "align": "left",
      "min-width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isVerson == true) ? _c('div', [_c('el-input', {
          staticStyle: {
            "width": "70px",
            "display": "inline-block"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.saveVersion(scope, scope.$index)
            }
          },
          model: {
            value: (_vm.plist[scope.$index].version),
            callback: function($$v) {
              _vm.$set(_vm.plist[scope.$index], "version", $$v)
            },
            expression: "plist[scope.$index].version"
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "el-icon-upload ",
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.saveVersion(scope, scope.$index)
            }
          }
        }, [_vm._v("保存")])], 1) : _vm._e(), _vm._v(" "), (scope.row.isVerson == false) ? _c('div', {
          staticClass: "editBox"
        }, [_c('span', [_vm._v(_vm._s(scope.row.version))]), _vm._v(" "), _c('i', {
          staticClass: "el-icon-edit icon_edit",
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.editVersion(scope.$index)
            }
          }
        })]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "has_jump",
      "label": "是否含二跳",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.has_jump == 1) ? _c('span', [_vm._v("是")]) : _c('span', [_vm._v("否")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "product_num",
      "label": "产品数量",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "creative_num",
      "label": "创意数量",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: scope.row.creative_num.online != scope.row.creative_num.count ? 'red' : ''
        }, [_vm._v(_vm._s(scope.row.creative_num.online) + "/" + _vm._s(scope.row.creative_num.count))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "space_num",
      "label": "广告位",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.space_num.count > 0) ? _c('span', {
          class: scope.row.space_num.online != scope.row.space_num.count ? 'red' : ''
        }, [_vm._v(_vm._s(scope.row.space_num.online) + "/" + _vm._s(scope.row.space_num.count))]) : _vm._e(), _vm._v(" "), (scope.row.space_num.count == 0) ? _c('span', [_vm._v("待接入广告位")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "update_time",
      "label": "更新时间",
      "align": "center",
      "sortable": "custom",
      "min-width": "110px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "start_time",
      "label": "发行游戏状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.status == '1' ? '正常' : '禁用'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "操作",
      "align": "center",
      "width": "220px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": scope.row.status == '1' ? 'success' : 'danger'
          },
          on: {
            "click": function($event) {
              return _vm.editStatus(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status == '1' ? '正常' : '禁用'))]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: '广告投放日志',
                params: {
                  index_id: scope.row.id
                },
                query: {
                  type: 'plan'
                }
              })
            }
          }
        }, [_vm._v("更新日志")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: '广告位',
                params: {
                  issued_app_id: scope.row.issued_app_id
                }
              })
            }
          }
        }, [_vm._v("广告位管理")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pageRow"
  }, [_c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c221ea6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/adControl/ADdelivery.vue
// module id = 1102
// module chunks = 2